import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import '@fontsource-variable/inter';
import '@fontsource/poppins/300.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
import '@fontsource-variable/cormorant-garamond';
import '@fontsource/roboto-mono';

import './app/globals.css';
import App from './App';
import { captureAdTags } from './site/forms/adTags';

// Keep the ad tags (utm_*, gclid, fbclid) of the page a visitor lands on, so a lead
// sent from another page later in the session still carries them.
captureAdTags();

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root element');

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
